import { memo, ReactNode } from 'react'
import { ButtonBase } from '@mui/material'
import { alpha } from '@mui/material/styles'
import AddIcon from '@mui/icons-material/Add'

type Props = {
    label: string
    onClick?: () => void
    disabled?: boolean
    icon?: ReactNode
}

/** Dashed "next row" that doubles as the empty state's call to action. */
const EmptyStateAction = ({ label, onClick, disabled, icon }: Props) => (
    <ButtonBase
        onClick={onClick}
        disabled={disabled}
        sx={(theme) => ({
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            mt: 0.75,
            py: '10px',
            px: 1.5,
            borderRadius: 2,
            fontSize: 13,
            fontFamily: 'inherit',
            color: theme.palette.text.primary,
            border: `1px dashed ${alpha(theme.palette.text.primary, 0.24)}`,
            transition: theme.transitions.create(['border-color', 'background-color'], {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
                borderColor: alpha(theme.palette.text.primary, 0.45)
            },
            '&.Mui-disabled': {
                color: theme.palette.text.disabled
            }
        })}
    >
        {icon ?? <AddIcon sx={{ fontSize: 16 }} />}
        {label}
    </ButtonBase>
)

export default memo(EmptyStateAction)
